/// <amd-module name="Test/TestResultsGridToolbar/Stores/TestResultsToolbarStore" />
import { Store } from "VSS/Reflux/Store";
import { IVssPageContext } from "VSS/Platform/Context";
import { TestResultsToolbarActionsHub } from "Test/TestResultsGridToolbar/Actions/TestResultsToolbarActionsHub";
import { IViewContextData, TestResultsGroupPivots } from "Test/common-util/Common";
import { FilterHelper } from "Test/common-util/FilterHelper";
import { FilterState } from "Test/common-util/Contracts/Filters";
import { TestResultsStore } from "Test/TestResultsGrid/Store/TestResultsTreeStore";
import {  TestResultsLeftViewActionHub} from "Test/TestResultsGrid/Actions/TestResultsGridActionHub";
import * as Telemetry from "Test/common-util/Telemetry";
import * as TelemetryConstants from "Test/common-util/TelemetryConstants";

export interface IToolBarState {
    groupBy: string;
    isFilterBarEnabled: boolean;
    filterState: FilterState;
    isFilterApplied: boolean;
    isReloadButtonEnabled: boolean;
    isManualMarkUnMarkFlakyEnabled: boolean;
}

export class TestResultsToolbarStore extends Store {
    private _state: IToolBarState;

    constructor(private _pageContext: IVssPageContext, 
                private _actionHub: TestResultsToolbarActionsHub,
                private _parentActionHub:  TestResultsLeftViewActionHub,
                private _resultStore: TestResultsStore,
                private _artifactData: IViewContextData) {
        super("");
        this._state = this._getDefaultState();
        this._actionHub.onGroupByChanged.addListener(this._updateGroupBy);
        this._actionHub.filterChanged.addListener(this._onFilterUpdated);
        this._actionHub.onToggleFilter.addListener(this._toggleFilterState);
        this._actionHub.updateReloadButton.addListener(this._updateReloadButton);
        this._actionHub.updateManualMarkUnMarkFlakyValue.addListener(this._updateMarkUnMarkFlakyButton);
        this._resultStore.addChangedListener(this._onTestResultsStoreChange);
        this._parentActionHub.enableViewMoreTests.addListener(() => this._updateReloadButton(true));
    }

    private _updateGroupBy = (groupBy: string)  => { 
        this._state.groupBy = groupBy;
        this.emitChanged();
    }

    private _toggleFilterState = ()  => { 
        this._state.isFilterBarEnabled = !this._state.isFilterBarEnabled;
        Telemetry.publishEvent(this._pageContext, this._artifactData, TelemetryConstants.featureTestTab_FilterButtonClicked,
            { "filterActive": this._state.isFilterBarEnabled });
        this.emitChanged();
    }

    private _onFilterUpdated = (filterState: FilterState)  => { 
        const filterApplied = !this.isFilterStateEmpty(filterState);
        if (filterApplied === this._state.isFilterApplied) {
            return;
        }

        this._state.filterState = filterState;
        this._state.isFilterApplied = filterApplied;
        this.emitChanged();
    }


    private _onTestResultsStoreChange = ()  => { 

        this.emitChanged();
    }

    private _updateReloadButton = (isReloadButtonEnabled: boolean)  => { 
        this._state.isReloadButtonEnabled = isReloadButtonEnabled;

        this.emitChanged();
    }

    private _updateMarkUnMarkFlakyButton = (value: boolean)  => { 
        this._state.isManualMarkUnMarkFlakyEnabled = value;

        this.emitChanged();
    }

    private _getDefaultState(): IToolBarState {
        return {
            groupBy: TestResultsGroupPivots.Group_By_Test_Run,
            isFilterBarEnabled: true,
            isFilterApplied: true,
            filterState: FilterHelper.getInitialFilterState(),
            isReloadButtonEnabled: false,
            isManualMarkUnMarkFlakyEnabled: false
        } as IToolBarState;
    }

    private isFilterStateEmpty(filterState: FilterState) {
        for (let filter in filterState) {
            if (filterState.hasOwnProperty(filter)) {
                return false;
            }
        }
        return true;
    }

    public getState() {
        return this._state;
    }
}
